<template>
    <b-skeleton-wrapper :loading="loading">
        <section-box class="section-tabs">
            <template #header>
                <!-- select box -->
                <div class="row">
                    <div class="col-12 cloud-padd">
                        <div class="list-btn d-flex flex-row align-items-center kd-tab-core">
                            <b-skeleton type="button" class="mr-1"></b-skeleton>
                            <b-skeleton type="button" class="mr-1"></b-skeleton>
                            <b-skeleton type="button" class="mr-1"></b-skeleton>
                        </div>
                    </div>
                </div>

                <!-- info box -->
                <div class="row pt-3">
                    <div class="col-12">
                        <div class="tab-content" id="myTabContent">
                            <div class="active show tab-pane fade">
                                <slot name="body"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <!-- calculator box -->
                <div class="calculator-box d-flex flex-column flex-md-row pb-4 pt-1">
                    <div class="d-flex flex-column justify-content-center price-box">
                        <div class="d-flex flex-column package-item">
                            <div class="d-flex flex-row justify-content-between">
                                <div>
                                    <b-skeleton type="button" width="300px"></b-skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- calculator total, buy now -->
                    <div class="ml-md-auto mt-3 mt-md-0">
                        <b-skeleton type="button" width="200px"></b-skeleton>
                    </div>
                </div>
            </template>
        </section-box>
    </b-skeleton-wrapper>
</template>
<script>
import { PROMOTION } from '../../configs/constants';
export default {
    props: {
        idSection: {
            type: String,
            default: 'fpt-camera',
        },
        title: {
            type: String,
            default: '',
        },

        tabs: {
            type: Array,
        },
        value: {
            type: Object,
        },
        onChange: {
            type: Function,
            require: false,
            default: () => { },
        },
        loading: {
            type: Boolean,
        },
        optionQuantity: {
            type: Object,
        },
        module: {
            type: String,
        },
        label: {
            type: Object,
            default: () => ({
                buyNow: 'Mua ngay',
                comingSoon: 'Chưa mở bán',
            }),
        },
    },
    data: function () {
        return {
            PromotionPrice: PROMOTION.PROMOTIONPRICE,
            PromotionTag: PROMOTION.PROMOTIONTAG,
        };
    },
    watch: {
        loading() {
            // this.calculatorPrice(this.tabs.find((tab) => tab.id === this.value) ?? this.tabs[0]);
            // this.setBanner();
        },
    },
    computed: {
        totalPrice() {
            const price = this.value.RealPromotionMonth * this.value.Qty;
            return price;
        },
        commingSoon() {
            const commingSoon = this.value.RealPromotionMonth == 0;
            this.$emit('computed-commingSoon', commingSoon)
            return commingSoon
        },
    },
    created() {
        //
    },
    mounted() {
        // this.setBanner();
    },
    methods: {

        setBanner() {
            if (this.currentTab.banner) {
                this.$store.dispatch('fptplaybox/updateSelectedBanner', this.currentTab.banner);
            }
        },
        changeTab(tab) {
            // if (tab.banner) this.$store.dispatch('fptplaybox/updateSelectedBanner', tab.banner);
            this.$emit('input', tab);
            this.$router.replace({ path: `/${this.module}/${tab.CmsContent.route_name}` }).catch(() => { });
            this.$emit('get-meta', tab.CmsContent.route_name);
        },
        onSubmit() {
            this.$emit('onProgress');
        },
    },
};
</script>
<style lang="scss">
.section-spiner__margin--5px {
    margin: 5px;
}

.section-tabs {
    .price-box {
        >div:not(:last-child) {
            margin-bottom: 20px;
        }
    }

    .btn-buy {
        display: block !important;
    }
}

.kd-fplay-btn-full {
    width: 50%;
}

.kv-fplay-tab {
    padding-right: 15px !important;
    padding-left: 15px !important;
    color: #000;
    margin-right: 10 !important;
    border-bottom: 1px solid #fff !important;
}

.active_fplay {
    background: #ff8840 !important;
    -webkit-background: #ff8840 !important;
    border-radius: 4px 4px 0px 0px !important;
    color: #fff !important;
    border-bottom: 1px solid #ff8840 !important;
}

@media (max-width: 668px) {
    .kd-fplay-btn-full {
        width: 100%;
    }
}

.list-btn {
    margin: 9px 9px 0 !important;
    border-bottom: 1px solid #e8e8e8;
}

@media (max-width: 668px) {
    .kd-fplay-btn-full {
        width: 100%;
    }

    .sec-plb .list-btn a {
        margin-right: 5px !important;
    }

    .kv-fplay-tab {
        padding-right: 15px !important;
        padding-left: 15px !important;
    }

    .cloud-padd {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .hidden_mobile {
        display: none !important;
    }

    .scrollable_tab {
        flex-wrap: nowrap !important;
        overflow-x: scroll;
        padding-bottom: 5px;
    }
}

.nav-tabs {
    display: inline-flex !important;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.text-cloud {
    color: #000000;
}

@media screen and (max-width: 425px) {
    .tab-seo {
        font-size: 14px !important;
        font-weight: 700;
    }
}
</style>
